export default __webpack_public_path__ + "static/media/floralGirl.14d7640b.jpg";